import { render, staticRenderFns } from "./selectBom.vue?vue&type=template&id=2bc3f2ba&scoped=true&"
import script from "./selectBom.vue?vue&type=script&lang=js&"
export * from "./selectBom.vue?vue&type=script&lang=js&"
import style0 from "./selectBom.vue?vue&type=style&index=0&id=2bc3f2ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3f2ba",
  null
  
)

export default component.exports